// extracted by css-extract-rspack-plugin
export default {"cls1":"Search-cls1_yZZ","cls2":"Search-cls2_iaY Search-cls1_yZZ","wide":"Search-wide_GMX"};